// Utility to clean cart from test/dummy items
export const cleanCartFromTestItems = () => {
  
  // Clear localStorage if cart data is stored there
  const possibleKeys = [
    'cart',
    'reduxPersist:cart',
    'cartItems',
    'persist:cart',
    'redux-cart'
  ]
  
  possibleKeys.forEach(key => {
    const stored = localStorage.getItem(key)
    if (stored) {
      try {
        const parsed = JSON.parse(stored)
        
        // If it contains cart items, check for test items
        if (parsed.items && Array.isArray(parsed.items)) {
          const testItems = parsed.items.filter((item: any) => item.id === '5' || item.id === 5)
          if (testItems.length > 0) {
            
            // Remove test items
            const cleanedItems = parsed.items.filter((item: any) => item.id !== '5' && item.id !== 5)
            const cleanedData = { ...parsed, items: cleanedItems }
            
            localStorage.setItem(key, JSON.stringify(cleanedData))
          }
        }
      } catch (error) {
      }
    }
  })
  
}

// Comprehensive cleanup function to clear ALL user data after payment completion
export const clearAllUserData = () => {
  try {
    
    // Clear specific sessionStorage items instead of clearing everything
    const sessionStorageKeysToClear = [
      'paymentData',
      'orderData',
      'orderCartData',
      'orderToken',
      'urlParams',
      'currentUrl',
      'currentSearchParams',
      'originalUrl',
      'cartState',
      'hasCleared'
    ]
    
    sessionStorageKeysToClear.forEach(key => {
      if (sessionStorage.getItem(key)) {
        sessionStorage.removeItem(key)
      }
    })
    
    // Clear specific localStorage items
    const localStorageKeysToClear = [
      'auth_token',
      'phone_number',
      'cart',
      'reduxPersist:cart',
      'cartItems',
      'persist:cart',
      'redux-cart',
      'orderData',
      'paymentData',
      'urlParams',
      'currentUrl',
      'currentSearchParams',
      'originalUrl'
    ]
    
    localStorageKeysToClear.forEach(key => {
      if (localStorage.getItem(key)) {
        localStorage.removeItem(key)
      }
    })
    
    // Clear Redux persist data
    const reduxPersistKeys = Object.keys(localStorage).filter(key => 
      key.startsWith('persist:') || key.startsWith('redux')
    )
    
    reduxPersistKeys.forEach(key => {
      localStorage.removeItem(key)
    })
    
    // Clear any remaining cart-related data
    const remainingKeys = Object.keys(localStorage)
    const cartRelatedKeys = remainingKeys.filter(key => 
      key.toLowerCase().includes('cart') || 
      key.toLowerCase().includes('order') || 
      key.toLowerCase().includes('payment') ||
      key.toLowerCase().includes('user') ||
      key.toLowerCase().includes('customer')
    )
    
    cartRelatedKeys.forEach(key => {
      localStorage.removeItem(key)
    })
    
  } catch (error) {
  }
}

// New function specifically for success page cleanup - preserves auth data
export const clearSuccessPageData = () => {
  try {
    
    // Only clear payment and order related data, preserve auth
    const sessionStorageKeysToClear = [
      'paymentData',
      'orderData',
      'orderCartData',
      'orderToken',
      'pay_intent',
      'pay_state',
      'paymob_order_id',
      'currentOrderToken',
      'currentOrderData',
      'currentOrderId',
      'currentOrderCartData',
      'orderDetailsUrl',
      'orderApiUrl',
      'successOrderId',
      'paymentSuccess',
      'orderStateData'
    ]
    
    sessionStorageKeysToClear.forEach(key => {
      if (sessionStorage.getItem(key)) {
        sessionStorage.removeItem(key)
      }
    })
    
    // Clear cart data but preserve auth
    const localStorageKeysToClear = [
      'cart',
      'reduxPersist:cart',
      'cartItems',
      'persist:cart',
      'redux-cart'
    ]
    
    localStorageKeysToClear.forEach(key => {
      if (localStorage.getItem(key)) {
        localStorage.removeItem(key)
      }
    })
    
  } catch (error) {
  }
}

// Function to clear all data after successful payment/order completion
export const clearAllDataAfterPayment = () => {
  try {
    // Clear all sessionStorage data
    const sessionStorageKeysToClear = [
      'paymentData',
      'orderData',
      'orderCartData',
      'orderToken',
      'pay_intent',
      'pay_state',
      'paymob_order_id',
      'currentOrderToken',
      'currentOrderData',
      'currentOrderId',
      'currentOrderCartData',
      'orderDetailsUrl',
      'orderApiUrl',
      'successOrderId',
      'paymentSuccess',
      'orderStateData',
      'urlParams',
      'currentUrl',
      'currentSearchParams',
      'originalUrl',
      'cartState',
      'hasCleared'
    ]
    
    sessionStorageKeysToClear.forEach(key => {
      if (sessionStorage.getItem(key)) {
        sessionStorage.removeItem(key)
      }
    })
    
    // Clear all localStorage data including auth
    const localStorageKeysToClear = [
      'auth_token',
      'phone_number',
      'cart',
      'reduxPersist:cart',
      'cartItems',
      'persist:cart',
      'redux-cart',
      'orderData',
      'paymentData',
      'urlParams',
      'currentUrl',
      'currentSearchParams',
      'originalUrl'
    ]
    
    localStorageKeysToClear.forEach(key => {
      if (localStorage.getItem(key)) {
        localStorage.removeItem(key)
      }
    })
    
    // Clear Redux persist data
    const reduxPersistKeys = Object.keys(localStorage).filter(key => 
      key.startsWith('persist:') || key.startsWith('redux')
    )
    
    reduxPersistKeys.forEach(key => {
      localStorage.removeItem(key)
    })
    
    // Clear any remaining cart-related data
    const remainingKeys = Object.keys(localStorage)
    const cartRelatedKeys = remainingKeys.filter(key => 
      key.toLowerCase().includes('cart') || 
      key.toLowerCase().includes('order') || 
      key.toLowerCase().includes('payment') ||
      key.toLowerCase().includes('user') ||
      key.toLowerCase().includes('customer')
    )
    
    cartRelatedKeys.forEach(key => {
      localStorage.removeItem(key)
    })
    
    console.log('✅ All data cleared after payment completion')
  } catch (error) {
    console.error('❌ Error clearing data after payment:', error)
  }
}

// Export function to be called from console for debugging
declare global {
  interface Window {
    cleanCart: () => void
    clearAllUserData: () => void
    clearSuccessPageData: () => void
    clearAllDataAfterPayment: () => void
  }
}

// Make functions available globally for debugging
if (typeof window !== 'undefined') {
  window.cleanCart = cleanCartFromTestItems
  window.clearAllUserData = clearAllUserData
  window.clearSuccessPageData = clearSuccessPageData
  window.clearAllDataAfterPayment = clearAllDataAfterPayment
}